<template>
  <div class="hvh-flex column space-between">
    <div class="hvh-flex space-between">
      <h2 class="hvh-h5 mb-4">Age Distribution</h2>
      <div>
        <label class="bold" v-if="hasAgeAtIndex">
          <span class="clickable" :class="{ underline: showAgeAtIndex }" @click="showAgeAtIndex = true">Age at Index</span> |
          <span class="clickable" :class="{ underline: !showAgeAtIndex }" @click="showAgeAtIndex = false">Current Age</span>
        </label>
        <label class="bold ml-3" v-if="canShowChildOption">
          <span class="clickable" :class="{ underline: showChildAgeDistribution }" @click="showChildAgeDistribution = true">Child</span> |
          <span class="clickable" :class="{ underline: !showChildAgeDistribution }" @click="showChildAgeDistribution = false">Adult</span>
        </label>
      </div>
    </div>
    <HvhChart :options="barChartAgeOptions" :visualization="barChartAgeData" height="300px" @item-clicked="emitValue" />
  </div>
</template>

<script>
import { customNumberFormat } from '../../../../libraries/common';
import HvhChart from '../../../charts/HvhChart.vue';
export default {
  components: { HvhChart },
  props: ['cohort', 'value'],
  data() {
    return {
      showChildAgeDistribution: false,
      showAgeAtIndex: false,
      barChartAgeOptions: {
        grid: {
          left: '30px',
          right: '30px',
        },
        series: [{ barMaxWidth: 30 }],
        tooltip: {
          formatter: params => {
            var count = this.barChartAgeData.data[params.dataIndex]["count"]
            return `${params.name}<br>${params.marker}${customNumberFormat(count)}`;
          }
        },
        yAxis: {
          axisLabel: {
            formatter: '{value}%'
          },
          name: 'Percent of Total',
          nameGap: 45
        }
      },
    };
  },
  computed: {
    hasAgeAtIndex() {
      return this.cohort.cohortStatistic.cohortAgeAtIndexStatistics?.any();
    },
    ageStatistics() {
      return this.showAgeAtIndex ? this.cohort.cohortStatistic.cohortAgeAtIndexStatistics : this.cohort.cohortStatistic.cohortAgeStatistics;
    },
    canShowChildOption() {
      return ['cohortAgeAtIndexStatistics', 'cohortAgeStatistics']
        .any(key => this.cohort.cohortStatistic[key]
          .filter(f => f.minAge < 18 && f.count)
          .groupBy(f => `${f.minAge}-${f.maxAge} `).length);
    },
    barChartAgeData() {
      var allData = this.ageStatistics.sortBy(f => f.minAge);
      var sum = allData.sum(f => f.count);

      var groupFnc = this.showChildAgeDistribution ?
        f => (f.minAge < 18 ? `${f.minAge} -${f.maxAge} ` : null)
        : f => (f.minAge < 18 ? '0-17' : `${f.minAge}${f.maxAge > 65 ? '+' : '-' + f.maxAge}`);

      const data = allData
        .groupBy(groupFnc)
        .filter(f => f.key)
        .map(f => {
          var count = f.items.sum(g => g.count);
          return {
            ageRange: f.key,
            cohortPercent: Math.round(count * 10000 / sum) / 100,
            count,
            color: (this.value || []).any() && !(this.value || []).includes(f.key) && 'rgb(216,216,216)',
          }
        });

      return {
        visualization_type: 'barchart',
        name_field: 'ageRange',
        value_field: 'cohortPercent',
        data,
      };
    },
  },
  methods: {
    emitValue(event) {
      var value = (this.value?.length !== this.barChartAgeData.data.length && this.value) || [];
      var sortedValue = value
        .toggle(event.ageRange)
        .sortBy(f => f);
      this.$emit('input', sortedValue);
    },
  },
}
</script>